import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './index.scss';

const About = () => {
  const location = useLocation();
  const path = location.pathname || '/about';

  const section = (() => {
    if (path.startsWith('/about/company')) return 'company';
    if (path.startsWith('/about/business')) return 'business';
    if (path.startsWith('/about/contact')) return 'contact';
    return 'home';
  })();

  const renderContent = () => {
    if (section === 'company') {
      return (
        <section className="about-section">
          <h2>关于我们</h2>
          <p>公司全称：四川小唐人文化科技有限公司（Sichuan Xiaotangren Culture Technology Co., Ltd.）</p>
          <p>统一社会信用代码：91510100MAE5FCRA5P</p>
          <p>注册地址：成都市高新区南华路1616号1栋2单元2层216号</p>
          <p>法定代表人：王明</p>
          <p>成立日期：2024年11月18日</p>
          <p>营业期限：长期</p>
          <p>公司简介：四川小唐人文化科技有限公司为依法设立并持续经营的企业主体，面向软件开发、移动应用开发与信息技术服务等方向开展业务，严格遵循国家相关法律法规及行业规范，持续完善产品与服务质量。</p>
        </section>
      );
    }
    if (section === 'business') {
      return (
        <section className="about-section">
          <h2>业务范围</h2>
          <p>一般项目：软件开发；人工智能基础软件开发；数字内容制作服务（不含出版发行）；教育咨询服务（不含涉许可审批的教育培训活动）；软件销售；互联网销售（除销售需要许可的商品）；组织文化艺术交流活动；文艺创作；数字创意产品展览展示服务；摄影扩印服务；会议及展览服务；广告设计、代理；广告制作；票务代理服务；摄像及视频制作服务。（除依法须经批准的项目外，凭营业执照依法自主开展经营活动）</p>
        </section>
      );
    }
    if (section === 'contact') {
      return (
        <section className="about-section">
          <h2>联系我们</h2>
          <p>公司地址：成都市高新区南华路1616号1栋2单元2层216号</p>
          <p>联系电话：17835398086</p>
          <p>联系邮箱：wangming@xiaotangrentech.cn</p>
        </section>
      );
    }
    return (
      <section className="about-section">
        <h2>首页（公司简介）</h2>
        <p>四川小唐人文化科技有限公司（Sichuan Xiaotangren Culture Technology Co., Ltd.）是一家专注于软件开发与信息技术服务的企业，围绕移动应用开发、数字内容与技术服务开展业务。公司依法合规经营，持续提供稳定、规范的产品与服务，支持教育类与数字化场景下的应用建设与运营。</p>
      </section>
    );
  };

  return (
    <div className="about-page">
      <header className="about-header">
        <h1>四川小唐人文化科技有限公司</h1>
        <p className="about-tagline">Sichuan Xiaotangren Culture Technology Co., Ltd.</p>
      </header>

      <nav className="about-nav">
        <Link className={section === 'home' ? 'active' : ''} to="/about">首页</Link>
        <Link className={section === 'company' ? 'active' : ''} to="/about/company">关于我们</Link>
        <Link className={section === 'business' ? 'active' : ''} to="/about/business">业务范围</Link>
        <Link className={section === 'contact' ? 'active' : ''} to="/about/contact">联系我们</Link>
      </nav>

      {renderContent()}

      <footer className="about-footer">
        Copyright © 2026 四川小唐人文化科技有限公司 版权所有
      </footer>
    </div>
  );
};

export default About;
